export default __webpack_public_path__ + "static/conect-2361dc2dc160c64fecc1a3f76a58ba9b.svg";